e360.service('mediaApi', [
   'apiHelper', 'fileDownload',
   function (apiHelper, fileDownload) {
      return {
         get: function (params) {
            return apiHelper.get('mediaFiles', params);
         },
         download: function(file) {
            return new fileDownload(file.url, {download: true}).get();
         },
         createJob: function (params) {
            return apiHelper.post(apiHelper.getApiUrl('mediaFiles/jobs', params));
         },
         getJobs: function () {
            return apiHelper.get('mediaFiles/jobs');
         },
         downloadZip: function (job) {
            return new fileDownload(apiHelper.getApiUrl('mediaFiles/jobs/' + job.id)).get();
         }
      };
   }
]);
